module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-1800.cd98199d.svg";